

const Shimmer = () => {

    return (

        <div className="shimmer-container">

            <div className="shimmer-buttons">

                <button className="shimmer-filter"></button>

                <div className="shimmer-search">

                    <input type="search" className="shimmer-search-box" />

                </div>

            </div>

            <div className="shimmer-cards">

                <div className="shimmer-card">
                    <div className="shimmer-img"></div>
                    <div className='shimmer-first-line'></div>
                    <div className='shimmer-second-line'></div>
                </div>

                <div className="shimmer-card">
                    <div className="shimmer-img"></div>
                    <div className='shimmer-first-line'></div>
                    <div className='shimmer-second-line'></div>
                </div>

                <div className="shimmer-card">
                    <div className="shimmer-img"></div>
                    <div className='shimmer-first-line'></div>
                    <div className='shimmer-second-line'></div>
                </div>

                <div className="shimmer-card">
                    <div className="shimmer-img"></div>
                    <div className='shimmer-first-line'></div>
                    <div className='shimmer-second-line'></div>
                </div>

                <div className="shimmer-card">
                    <div className="shimmer-img"></div>
                    <div className='shimmer-first-line'></div>
                    <div className='shimmer-second-line'></div>
                </div>

                <div className="shimmer-card">
                    <div className="shimmer-img"></div>
                    <div className='shimmer-first-line'></div>
                    <div className='shimmer-second-line'></div>
                </div>

                <div className="shimmer-card">
                    <div className="shimmer-img"></div>
                    <div className='shimmer-first-line'></div>
                    <div className='shimmer-second-line'></div>
                </div>

                <div className="shimmer-card">
                    <div className="shimmer-img"></div>
                    <div className='shimmer-first-line'></div>
                    <div className='shimmer-second-line'></div>
                </div>

            </div>
        </div>
    )
}

export default Shimmer;